<template>
  <div class="h4h-form">
    <div
      v-if="packages.length > 0"
      id="addToCartVue"
      class="purchasing_box"
    >
      <h2 class="pricing_header">
        {{ $t('formPackage.packagePricing') }}
        <CurrencyDropdown @currency-emit="updateCurrency" />
      </h2>

      <div id="packageForm">
        <div
          class="heading"
        >
          <label class="occupancy-desc-box">
            Step 1: {{ packages.length > 1 ?
              $t('formPackage.chooseYourPackage') :
              $t('formPackage.chooseYourQuantity') }}
            <i class="fa fa-chevron-down" />
          </label>
        </div>

        <SubPackageInputFields
          v-if="checkForSubpackage()"
          :currency="currency"
          :rate="rate"
          :packages="packages"
        />

        <SoloPackageInputField
          v-else
          :currency="currency"
          :rate="rate"
          :packages="packages"
        />

        <div class="new_order_item">
          <AddToCart
            :form-btn-text="formBtnText"
            :qtyhotel="hotelQty"
            :qtypackage="packageQty"
            :idpackage="idPackage"
            @order-item-added="redirectToOrderItemHotels"
          />
        </div>
        <PriceInfo
          :currency="currency"
          :rate="rate"
        />


        <span class="tax_disclaimer small">
          {{ $t('taxDisclaimer') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
/* global locale */

import { CurrencyDropdown} from '../../../default/currency_convert'
import AddToCart from './add-to-cart'
import SubPackageInputFields from './subpackage-input-fields'
import SoloPackageInputField from './single-package-input-field'
import PriceInfo from './price-info.vue'
// import FetchCall from '../../local_fetch_call'


export default {
  components: {
    AddToCart,
    CurrencyDropdown,
    SubPackageInputFields,
    PriceInfo,
    SoloPackageInputField
  },

  data() {
    return {
      chargeableCurrencies: [],
      currency: 'USD',
      hotelQty: 0,
      packageQty: 0,
      packages: [],
      rate: 1.0,
    }
  },

  computed: {
    formBtnText() {
      return this.$t('formPackage.continue')
    },

    idPackage() {
      if (this.$store.state.packages.selectedPackage) {
        return this.$store.state.packages.selectedPackage.id
      } else {
        return null
      }
    }
  },

  created() {
    let h4hPackageDiv = document.getElementById('h4hPackageCartFormData')

    if (h4hPackageDiv) {
      this.packages = JSON.parse(h4hPackageDiv.dataset.packages)

      this.chargeableCurrencies = this.packages[0].chargeable_currencies
    }
  },

  methods: {
    updateCurrency(errors, currency, rate) {
      if (currency && rate) {
        this.currency = currency
        this.rate = rate
      }
    },

    checkForSubpackage(){
      return this.packages[0].group!=='Package'
    },

    redirectToOrderItemHotels(item) {
      if (item.id) {
        if(item.hotel_behavior!='no_hotels'){
          window.location.replace(`/${locale}/cart/items/${item.id}/hotels`)
        } else {
          window.location.replace(`/${locale}/cart/checkout`)
        }
      }
    }
  }
}
</script>
